module.exports = __webpack_public_path__ + "static/media/c31pro-connect.5be14aa2.png";